import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { espacamento } from '../../styles/constants/sizes';

export const ListaNoticiaBox = styled.div`
  display: flex; 
  margin-bottom: 30px;
  cursor: pointer;
  flex-direction: column;
  height: 400px;
  position: relative;
  box-shadow: 0px 0px 5px #dfdfdf;

  :hover {
    transform: translateY(-4px);
    box-shadow: 4px 4px 10px 0px rgb(0 0 0 / 20%);
  }
`;

export const BoxImagem = styled.div`
  display: flex;
  alignItems: center; 
  justifyContent: center;
  border: 1px solid #0000000a;
`;

export const InfoContainer = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;  
  overflow: hidden;
`;
